"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOCUSABLE_ELEMENT_SELECTORS = exports.CLOSE_BUTTON_DATA_TEST = exports.SIZES = void 0;
var SIZES = {
  SMALL: "small",
  NORMAL: "normal",
  LARGE: "large"
};
exports.SIZES = SIZES;
var CLOSE_BUTTON_DATA_TEST = "ModalCloseButton";
exports.CLOSE_BUTTON_DATA_TEST = CLOSE_BUTTON_DATA_TEST;
var FOCUSABLE_ELEMENT_SELECTORS = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
exports.FOCUSABLE_ELEMENT_SELECTORS = FOCUSABLE_ELEMENT_SELECTORS;